import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Mail, Facebook, Linkedin, Instagram, Youtube, ArrowRight } from 'lucide-react';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { useToast } from '../hooks/use-toast';
import { subscribeNewsletter } from '../lib/api';

const Footer = () => {
  const [email, setEmail] = useState('');
  const { toast } = useToast();

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      const res = await subscribeNewsletter(email, 'footer');
      toast({ title: 'Inscription confirmée !', description: res?.message === 'Déjà inscrit' ? `${email} est déjà inscrit à notre newsletter.` : `Vous recevrez nos dernières actualités à ${email}.` });
      setEmail('');
    } catch (err) {
      toast({ title: 'Erreur', description: err?.response?.data?.detail || "Impossible de vous inscrire.", variant: 'destructive' });
    }
  };

  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-5 lg:px-8 pt-16 sm:pt-20 pb-[max(2.5rem,env(safe-area-inset-bottom,0px))]">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 mb-14">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-5">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-teal-500 to-emerald-600 flex items-center justify-center">
                <Sparkles className="w-5 h-5 text-white" strokeWidth={2.5} />
              </div>
              <span className="text-2xl font-bold text-white">Medelia</span>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed mb-6 max-w-sm">
              La plateforme qui simplifie la formation continue des professionnels de santé. Trouvez, financez et suivez vos formations en toute sérénité.
            </p>
            <form onSubmit={handleSubscribe} className="flex flex-col gap-2 sm:flex-row sm:items-stretch max-w-md">
              <Input
                type="email"
                required
                placeholder="Votre email professionnel"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="bg-slate-800 border-slate-700 text-white placeholder:text-slate-500 focus-visible:ring-teal-500"
              />
              <Button
                type="submit"
                className="h-11 min-h-11 w-full bg-teal-500 hover:bg-teal-600 text-white sm:h-auto sm:min-h-11 sm:w-auto sm:shrink-0 touch-manipulation"
              >
                <ArrowRight className="w-4 h-4" />
              </Button>
            </form>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Plateforme</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/formations" className="hover:text-teal-400 transition-colors">Catalogue</Link></li>
              <li><Link to="/a-propos" className="hover:text-teal-400 transition-colors">À propos</Link></li>
              <li><Link to="/actualites" className="hover:text-teal-400 transition-colors">Actualités</Link></li>
              <li><Link to="/inscription" className="hover:text-teal-400 transition-colors">S'inscrire</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Financement</h4>
            <ul className="space-y-3 text-sm">
              <li className="hover:text-teal-400 transition-colors cursor-pointer">DPC</li>
              <li className="hover:text-teal-400 transition-colors cursor-pointer">FIFPL</li>
              <li className="hover:text-teal-400 transition-colors cursor-pointer">OPCO</li>
              <li className="hover:text-teal-400 transition-colors cursor-pointer">CPF</li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2"><Mail className="w-4 h-4 mt-0.5 text-teal-400" /><span>contact@medelia-sante.com</span></li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-5 pt-8 border-t border-slate-800">
          <p className="text-xs text-slate-500">© 2026 Medelia. Tous droits réservés. Organisme Qualiopi certifié.</p>
          <div className="flex items-center gap-3">
            {[Facebook, Linkedin, Instagram, Youtube].map((Icon, i) => (
              <a
                key={i}
                href="#"
                className="inline-flex min-h-11 min-w-11 items-center justify-center rounded-lg bg-slate-800 hover:bg-teal-500 touch-manipulation transition-colors"
              >
                <Icon className="w-4 h-4" aria-hidden />
              </a>
            ))}
          </div>
          <div className="flex items-center gap-5 text-xs text-slate-500">
            <a href="#" className="hover:text-teal-400">Mentions légales</a>
            <a href="#" className="hover:text-teal-400">CGU</a>
            <a href="#" className="hover:text-teal-400">Confidentialité</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
